import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TrackingPage from "../../pages/TrackingPage";

export default function MainLayout() {
  const location = useLocation();
  const isTracking = location.pathname === '/tracking' || location.pathname === '/';
  
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  const pageContainerStyle = (isVisible) => ({
    display: isVisible ? 'flex' : 'none',
    flex: 1,
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden'
  });

  return (
    <div className="dashboard-layout">
      
      <button className="mobile-menu-toggle" onClick={toggleSidebar}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      </button>

      {isMobileSidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setIsMobileSidebarOpen(false)}></div>
      )}

      <Sidebar 
        isOpen={isMobileSidebarOpen} 
        closeSidebar={() => setIsMobileSidebarOpen(false)} 
      />

      <main className="main-content">
        <div style={pageContainerStyle(isTracking)}>
           <TrackingPage />
        </div>
        <div style={pageContainerStyle(!isTracking)}>
           <Outlet />
        </div>
      </main>
    </div>
  );
}